export const state = {
  layout: 'blank-layout',
  version: process.env.VUE_APP_VERSION,
  intervals: {},
  loading: false,
  darkModeEnabled: false,
  snackbarMessage: null,
  snackbarPosition: null,
  snackbarColor: null,
  themeMode: 'light'
}

export const getters = {
  GET_INTERVAL: state => ({ name }) => {
    return state.intervals[name]
  }
}

export const mutations = {
  SET_LAYOUT (state, payload = 'default') {
    state.layout = `${payload}-layout`
  },
  SET_INTERVAL (state, { name, interval }) {
    state.intervals[name] = interval
  },
  CLEAR_INTERVAL (state, { name }) {
    const interval = state.intervals[name]
    clearInterval(interval)
    delete state.intervals[name]
  },
  CLEAR_ALL_INTERVALS (state) {
    for (const key in state.intervals) {
      clearInterval(state.intervals[key])
    }
    state.intervals = {}
  },
  SET_LOADING (state, payload = false) {
    state.loading = payload
  },
  SET_DARK_MODE (state, payload = false) {
    state.darkModeEnabled = payload
    localStorage.setItem('darkMode', state.darkModeEnabled)
  },
  SET_THEME_MODE (state, theme = 'light') {
    state.themeMode = theme

    switch (theme) {
      case 'system':
        state.darkModeEnabled = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        break

      case 'dark':
        state.darkModeEnabled = true
        break

      case 'light':
        state.darkModeEnabled = false
        break

      default:
        state.darkModeEnabled = false
        break
    }

    localStorage.setItem('darkMode', state.darkModeEnabled)
    localStorage.setItem('themeMode', state.themeMode)
  },
  SET_SNACKBAR_MESSAGE (state, payload = null) {
    state.snackbarMessage = payload
  },
  SET_SNACKBAR_POSITION (state, payload = null) {
    state.snackbarPosition = payload
  },
  SET_SNACKBAR_COLOR (state, payload = null) {
    state.snackbarColor = payload
  }
}

export const actions = {
  init ({ commit }) {
    const enabled = localStorage.getItem('darkMode') === 'true'
    commit('SET_DARK_MODE', enabled)

    const theme = localStorage.getItem('themeMode')
    commit('SET_THEME_MODE', theme)
  },
  setInterval ({ getters, dispatch, commit }, { name, time = 60000 }) {
    const exists = getters.GET_INTERVAL({ name })

    if (!exists) {
      dispatch(`hsm/${name}`, {}, { root: true })
      commit('SET_INTERVAL', {
        name,
        interval: setInterval(() => {
          dispatch(`hsm/${name}`, {}, { root: true })
        }, time)
      })
    }
  },
  setPopup (context, { exists, url }) {
    if (!exists || (exists && exists.closed)) {
      const popup = window.open(
        url,
        '_blank',
        'scrollbars=yes,resizable=yes,status=yes,top=0,right=0,width=961,height=800'
      )
      return popup
    } else {
      exists.focus()
    }
  },
  showSnackbar ({ commit }, { message, position, color = null }) {
    commit('SET_SNACKBAR_POSITION', position)
    commit('SET_SNACKBAR_COLOR', color)
    commit('SET_SNACKBAR_MESSAGE', message)
  }
}
